export default "__VITE_ASSET__797aca9b__"